<template>
    <div class="user_descriptions">
        <div class="user_descr">
            <label class="form-label" for="user_pwa_text">
                {{ __t('PWA_' + this.article_type) }}
            </label>
            <vue-editor :editor-toolbar="editor_rules"  v-model="cur_article"></vue-editor>
        </div>
    </div>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
    name: "pwa_article",
    components: {
        VueEditor,
    },
    props : {
        article_type : {
            type : String
        },
        pwa : {
            type:Object
        }
    },

    data() {
        return {
            is_load: false,
            inp_fields : [],
            editor_rules :[
                ["bold", "italic", "underline","link"],
                [{ align: "center" }, { align: "right" },{ align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" },{ list: "check" }],
            ],
        }
    },

    computed : {
        cur_article : {
            get() {
                if(this.pwa.hasOwnProperty("articles")) {
                    if(this.pwa.articles.hasOwnProperty(this.article_type)) {
                        return this.pwa.articles[this.article_type];
                    }
                }
            },
            set(val) {
                try {
                    this.pwa.articles[this.article_type] = val;
                }
                catch (e) {
                    console.log('Type not found',e);
                }
            }

        }
    }
}
</script>

<style scoped>

</style>
